import { z } from '../zod.js';

export const AccountResponseValidationSchema = z
  .object({
    id: z.string().meta({
      description: 'Unique identifier for the seller account.',
      example: '507f1f77bcf86cd799439011',
    }),
    name: z.string().nullable().meta({
      description: 'Store slug, used as the default checkout subdomain.',
      example: 'mystore',
    }),
    displayName: z.string().nullable().meta({
      description: 'Store display name shown to customers.',
      example: 'My Store',
    }),
    logo: z
      .object({
        url: z.string().meta({ description: 'Publicly reachable URL of the store logo.' }),
      })
      .nullable()
      .meta({ description: 'Store logo, or null when none is set.' }),
  })
  .meta({ id: 'Account' });

export const GetAccountResponseValidationSchema = z.object({
  data: AccountResponseValidationSchema,
});
